import React from 'react';

// import components
import Table from 'components/partials/table';

// structure of the tableData.tableContent after getting parsed from JSON string
type TableContentData = {
    columns: string[];
    data: Record<string, string>[];
}

const TableBuilder: React.FC<{ tableData?: Queries.TableBlockFragment }> = ({ tableData }) => {

    if (!tableData) return null;

    const tableJson = typeof tableData.tableContent === 'object' && tableData.tableContent !== null
        ? JSON.stringify(tableData.tableContent)
        : tableData.tableContent ?? '';

    if (!tableJson) return null;

    const tableObject = JSON.parse(tableJson) as TableContentData;

    // Convert data to string[][]
    const rowData = tableObject.data.map(row =>
        tableObject.columns.map(column => row[column] ?? '')
    );

    return (
        <Table
            headline={tableData.heading ?? ''}
            columnHeaders={tableObject.columns ?? []}
            rowData={rowData}
        />
    );
}

export default TableBuilder;

/** 
 * example of the JSON string that gets parsed into the TableContentData object
 
{
  "columns": [
    "Utility Tax Classification",
    "Prior to March 2016",
    "Current"
  ],
  "data": [
    {
      "Utility Tax Classification": "Telephone Business",
      "Prior to March 2016": "6.0%",
      "Current": "7.5%"
    },
    {
      "Utility Tax Classification": "Cellular or Pager",
      "Prior to March 2016": "6.0%",
      "Current": "7.5%"
    }
  ]
}

*/